import 'firebase/remote-config';

const remoteConfig = firebase => firebase.remoteConfig();

export default remoteConfig;
